import { ThemeContext } from '@/theme/ThemeProvider';
import { useContext } from 'react';
import styled from 'styled-components';

const MInActiveSvg = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const fill = isDarkMode ? '#9897A0' : '#BDBDBD';

  return (
    <>
      <FirstLayer
        width="89"
        height="88"
        viewBox="0 0 89 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M75.6169 12.8862C58.4388 -4.2967 30.5878 -4.2967 13.4098 12.8862C12.1796 14.1167 11.0209 15.4188 9.94273 16.7853C9.58691 17.2593 9.68167 17.9318 10.1555 18.2877C10.6133 18.6311 11.2605 18.556 11.6253 18.1142C12.4246 17.1001 13.2757 16.12 14.1769 15.172L17.0718 18.0677C17.4812 18.4773 18.1428 18.488 18.5648 18.091C18.9975 17.6563 18.9957 16.9552 18.5612 16.5224C18.5595 16.5206 18.5577 16.5188 18.5559 16.517L15.6932 13.6535C23.187 6.4956 33.0822 2.39617 43.4405 2.16008V6.20943C43.4315 6.79966 43.8911 7.29331 44.4812 7.32729C45.073 7.34518 45.5683 6.88014 45.5862 6.28812C45.5862 6.27739 45.5862 6.26487 45.5862 6.25414V2.15829C55.9445 2.39438 65.8397 6.4956 73.3317 13.6553L70.469 16.5188C70.0327 16.9481 70.0273 17.651 70.4565 18.0874C70.4565 18.0874 70.4601 18.091 70.4618 18.0928C70.8838 18.4898 71.5454 18.4791 71.9549 18.0695L74.8498 15.1738C82.0074 22.6662 86.1057 32.566 86.3417 42.9272H82.2917C81.7017 42.9183 81.2082 43.3779 81.1742 43.9682C81.1563 44.5602 81.6212 45.0556 82.2131 45.0735C82.2238 45.0735 82.2363 45.0735 82.247 45.0735H86.3417C86.1057 55.4348 82.0074 65.3328 74.8498 72.8269L71.9871 69.9634C71.5758 69.5395 70.9035 69.5145 70.4618 69.908C70.0309 70.314 70.0095 70.9936 70.4154 71.4247C70.4225 71.4318 70.4297 71.4408 70.4386 71.4479L73.3335 74.3437C65.8415 81.5034 55.9463 85.6046 45.588 85.8389V81.7895C45.5969 81.1993 45.1374 80.7057 44.5491 80.6717C43.9572 80.6538 43.4619 81.1188 43.4441 81.7108C43.4441 81.7216 43.4441 81.7341 43.4441 81.7448V85.8407C33.0858 85.6046 23.1906 81.5034 15.6985 74.3437L18.5612 71.4801C18.985 71.0688 19.0101 70.3963 18.6167 69.9545C18.2108 69.5234 17.5313 69.502 17.1004 69.908C17.0914 69.9151 17.0843 69.9241 17.0771 69.9312L14.1823 72.8269C7.0246 65.3346 2.92634 55.4348 2.69031 45.0735H6.74029C7.33036 45.0825 7.82387 44.6228 7.85784 44.0344C7.87572 43.4423 7.41082 42.9469 6.81897 42.929C6.80824 42.929 6.79573 42.929 6.785 42.929H2.68495C2.8262 36.88 4.28527 30.933 6.95844 25.5046C7.22129 24.9734 7.00314 24.3295 6.4703 24.0666C5.93924 23.8037 5.29553 24.0219 5.03269 24.5549C-5.69933 46.3631 3.27322 72.7429 25.0752 83.478C41.9743 91.8002 62.2957 88.4377 75.6169 75.1145C92.7949 57.9316 92.7949 30.0727 75.6169 12.8898V12.8862Z"
          fill={fill}
        />
      </FirstLayer>

      <SecondLayer
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.5134 71.6808C56.1839 71.6808 72.1854 55.6748 72.1854 35.9986C72.1854 16.3224 56.1839 0.316406 36.5134 0.316406C16.8428 0.316406 0.841309 16.3242 0.841309 35.9986C0.841309 55.673 16.8446 71.6808 36.5134 71.6808ZM36.5134 2.4627C55.0002 2.4627 70.0397 17.5065 70.0397 35.9986C70.0397 54.4908 55.0002 69.5345 36.5134 69.5345C18.0265 69.5345 2.987 54.4908 2.987 35.9986C2.987 17.5065 18.0265 2.4627 36.5134 2.4627Z"
          fill={fill}
        />
      </SecondLayer>

      <ThirdLayer
        width="63"
        height="62"
        viewBox="0 0 63 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.7033 61.6621C38.1095 61.866 45.3387 59.3674 51.039 54.633C51.4968 54.2556 51.5612 53.5777 51.1839 53.1199C51.1284 53.0519 51.0659 52.9929 50.9943 52.941C50.5992 52.6477 50.0538 52.662 49.6747 52.9768C44.4732 57.298 37.8985 59.6213 31.1378 59.5248C15.6155 59.3244 3.02035 46.579 2.99353 31.0523C2.96492 15.286 15.7908 2.45291 31.5508 2.47258C47.1071 2.49226 59.8721 15.1429 60.033 30.7036C60.0974 36.3108 58.4989 41.8124 55.4377 46.511C55.1194 47.0101 55.266 47.6736 55.7649 47.9938C56.2531 48.305 56.9003 48.1726 57.2276 47.6951C60.523 42.6423 62.2449 36.7239 62.1769 30.691C62.0089 13.873 48.162 0.238645 31.3488 0.328074C14.3728 0.417503 0.61539 14.3756 0.849627 31.4315C1.06956 47.4912 14.65 61.249 30.7033 61.6657V61.6621Z"
          fill={fill}
        />
      </ThirdLayer>
    </>
  );
};

export default MInActiveSvg;

const FirstLayer = styled.svg`
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: -0.01%;
`;

const SecondLayer = styled.svg`
  position: absolute;
  left: 9.48%;
  right: 9.45%;
  top: 9.45%;
  bottom: 9.45%;
`;

const ThirdLayer = styled.svg`
  position: absolute;
  left: 15.17%;
  right: 15.14%;
  top: 15.15%;
  bottom: 15.14%;
`;
